import React from 'react';
import Sidebar from './Sidebar';
import { useLocation } from 'react-router-dom';

export default function Layout({ children }) {
  const location = useLocation();
  // Hide sidebar on login/register
  const hideSidebar = ['/login', '/register'].includes(location.pathname);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f8f9fa' }}>
      {!hideSidebar && <Sidebar />}
      <div
        style={{
          flex: 1,
          // marginLeft: hideSidebar ? 0 : 220, // Sidebar width
          padding: '32px 24px 24px 24px',
          transition: 'margin-left 0.2s',
        }}
      >
        {children}
      </div>
    </div>
  );
} 